<template>
  <div data-server-rendered="true" id="__nuxt" class="bannerBox">
    <!---->
    <div id="__layout">
      <div id="body">
        <div class="index_body">
          <div class="head_height">
            <div class="banner_box">
              <div class="banner page_width">
                <div class="ban_top">
                  <div class="logo" @click="showPageHome()"></div>
                  <div class="right flex">
                    <div class="no_login" v-if="!loginTrue" @click="loginUp()">
                      登录/注册
                    </div>
                    <div class="no_loginLeft" @click="myInformation" v-else>
                      <span>我的</span>
                    </div>
                    <div class="no_loginRight" v-if="loginTrue">
                      <span class="logout" @click="logout" v-if="loginTrue">退出</span>
                    </div>
                  </div>
                </div>
                <div class="ban_btn">
                  <div class="btn1" @click="existingEvidence()">我要存证</div>
                  <div class="btn2" @click="handleImport">批量存证</div>
                  <div class="btn1" @click="queryHashSslect()">我要查询</div>
                  <div class="btn2" @click="jumpToResultsLibrary()">存证库</div>
                </div>
              </div>
            </div>
          </div>

          <div class="step_box" v-if="showPage">
            <div class="step page_width">
              <div class="step_top">操作<span>流程</span><span>（免费试用）</span></div>
              <div class="step_lab">第一时间上链，生成永久证书，不可篡改</div>
              <div class="step_itm">
                <div class="itm_box">
                  <div class="num">1</div>
                  <div class="span">注册认证</div>
                </div>
                <div class="line"></div>
                <div class="itm_box">
                  <div class="num">2</div>
                  <div class="span">上传信息</div>
                </div>
                <div class="line"></div>
                <div class="itm_box">
                  <div class="num">3</div>
                  <div class="span">专家评估</div>
                </div>
                <div class="line"></div>
                <div class="itm_box">
                  <div class="num">4</div>
                  <div class="span">提交审核</div>
                </div>
              </div>

              <div class="step_itms">
                <div class="itm_box">
                  <div class="num">5</div>
                  <div class="span">生成证书</div>
                </div>
                <div class="line"></div>
                <div class="itm_box">
                  <div class="num">6</div>
                  <div class="span">撮合交易</div>
                </div>
                <div class="line"></div>
                <div class="itm_box">
                  <div class="num">7</div>
                  <div class="span">审核转让</div>
                </div>
                <div class="line"></div>
                <div class="itm_box">
                  <div class="num">8</div>
                  <div class="span">变更证书</div>
                </div>
              </div>
            </div>
          </div>

          <div class="reason_box" v-if="showPage">
            <div class="reason page_width">
              <div class="tit">为什么要做<span>科技成果存证</span></div>
              <div class="cont">
                <div class="cont_itm">
                  <img
                      style="height: 100px; width: 100px;
margin-bottom: 5px;"
                      src="../assets/img/hua.png"
                  />
                  <div class="label">泰山链</div>
                  <div class="text">
                    采用区块链技术，第一时间让成果上链，区块链具有永久保存、不可篡改的特性。
                  </div>
                </div>
                <div class="cont_itm">
                  <img
                      style="height: 100px; width: 100px; margin-bottom: 5px"
                      src="../assets/img/dunpai.png"
                      alt
                  />
                  <div class="label">法律保障</div>
                  <div class="text">
                    与科技部门、公证处合作，通过凭证，证明成果在存证时实际存在、内容完整且未被更改。
                  </div>
                </div>
                <div class="cont_itm">
                  <img
                      style="
                      height: 100px; width: 100px;
                      margin-bottom: 5px;

                    "
                      src="../assets/img/computer.png"
                      alt
                  />
                  <div class="label">快速便捷</div>
                  <div class="text">
                    采用加密技术确保数据安全，保护隐私，在线一站式操作，仅需1-2分钟完成存证。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="exchange_box" v-if="showPage">
            <div class="exchange page_width">
              <div class="ex_left">
                <div class="tit">为什么选<span>泰山科技大市场</span></div>
                <div class="itm">
                  <img src="../assets/img/true.png" alt/>
                  <div>政府机构认定的科技成果转化交易单位。</div>
                </div>
                <div class="itm">
                  <img src="../assets/img/true.png" alt/>
                  <div>
                    泰山区块链作底层，对科技成果确权，永久保存，不可篡改。
                  </div>
                </div>
                <div class="itm">
                  <img src="../assets/img/true.png" alt/>
                  <div>政府科技部门、公证单位作背书，科技成果确权有保障。</div>
                </div>
                <div class="itm">
                  <img src="../assets/img/true.png" alt/>
                  <div>
                    存证服务的同时，能够为持有方开展查询、交易的全流程服务。
                  </div>
                </div>
              </div>
              <div class="ex_rig">
                <img src="../assets/img/zhengshu.png" alt/>
              </div>
            </div>
          </div>
          <div id="responsibilities" class="problem_box_inline" v-if="showPage">
            <div style="width: 1200px; margin-top: 100px">
              <div class="pro_tit">
                常见<span style="color: #2238c2">问题</span>
              </div>
              <div class="pro_lab">什么是科技成果存证？</div>
              <div class="pro_cont mb40">
                科技成果存证是利用区块链技术记录和证明科技成果归属和权益状况的过程。创作者在作品创作完成后，将原始文件和相关信息上传至区块链平台，一旦数据上链，就会形成一个不可篡改且带有时间戳的记录，这便构成了对版权的确权存证。
              </div>
              <div class="pro_lab">科技成果存证和版权备案有什么区别？</div>
              <div class="pro_cont mb40">
                科技成果存证是利用区块链技术对作品进行存证，证明作品在某个时间点的版权归属；而传统的版权备案则是向国家版权局提交申请，经过审查后获得正式的版权证书。两者在法律效力上相同，但数字版权存证更加便捷、快速、成本低。
              </div>
              <div class="pro_lab">科技成果存证有什么作用？</div>
              <div class="pro_cont mb40">
                创作者，防止别人盗用或抄袭。如果有人侵犯了您的版权，这个存证可以作为证据，帮您更加有效的维权
              </div>
              <div></div>
              <div class="pro_lab">科技成果存证需要多长时间？</div>
              <div class="pro_cont mb40">
                系统正常运行的情况下，存证需要1-2分钟的时间
              </div>
              <div class="pro_lab">
                科技成果存证安全吗？会不会泄露我的信息？
              </div>
              <div class="pro_cont mb40">
                非常安全。存证平台使用先进的加密技术和区块链技术来保护您的作品和信息。不会把您的个人信息和作品内容泄露给任何人。
                科技成果存证后，我还能修改作品吗？
                一旦存证完成，原作品就不能再修改。因为存证就是为了证明该作品在某个时间点的状态，如果修改将无法证明，须再次进行存证。
              </div>
              <div class="pro_lab">科技成果存证的法律效力怎么样？</div>
              <div class="pro_cont mb40">
                存证平台是政府授权平台，提供可信时间凭证，存证内容可被司法机构认可，如果有人侵犯了您的版权，您向法院提起诉讼，存证信息将是有力证据。
              </div>
            </div>
          </div>

          <div class="form-container" style="margin-bottom: 90px" v-if="formShow">
            <!-- 步骤指示器 -->
            <div class="steps">
              <div class="step">
                <div class="step-number">1</div>
                <div class="step-text">注册认证</div>
              </div>
              <div>

              </div>
              <div class="step">
                <div class="step-number">2</div>
                <div class="step-text">上传信息</div>
              </div>
              <div class="step">
                <div class="step-number">3</div>
                <div class="step-text">专家评估</div>
              </div>
              <div class="step">
                <div class="step-number">4</div>
                <div class="step-text">提交审核</div>
              </div>
            </div>
            <div class="steps">
              <div class="step">
                <div class="step-number">5</div>
                <div class="step-text">生成证书</div>
              </div>
              <div class="step">
                <div class="step-number">6</div>
                <div class="step-text">撮合交易</div>
              </div>

              <div class="step">
                <div class="step-number">7</div>
                <div class="step-text">审核转让</div>
              </div>
              <div class="step">
                <div class="step-number">8</div>
                <div class="step-text">变更证书</div>
              </div>
            </div>
            <!-- 提示信息 -->
            <div class="notice">
              <!--              提示说明：上上作品名称、分类、题材、作品上传公益法定字节需要填写完整，一经生成，申请作者不可一次性删除修改。(本系统认证不作任何产权保护用)-->
              提示说明：上传科技成果证明材料需要填写完整，委托专家评估可暂存，所有存证均需官方审核，需耐心等待，一经审核通过，立马上链，生成证书，申请作者不可删除修改。(本系统认证不作任何产权保护用)
            </div>

            <!-- 表单内容 -->
            <el-form :model="form" :rules="rules" ref="rules">
              <div class="form-row">
                <label class="form-label required">成果名称:</label>
                <el-form-item prop="achievementName">
                  <el-input type="text" class="form-input" placeholder="请输入成果名称" v-model="form.achievementName"/>
                </el-form-item>
              </div>
              <div class="form-row">
                <label class="form-label required">成果持有单位/人:</label>
                <el-form-item prop="holdingUnit">
                  <el-input type="text" class="form-input" placeholder="请输入成果持有单位/人(多位可用 '、'  隔开)"
                            v-model="form.holdingUnit"/>
                </el-form-item>
              </div>

              <!-- 持有单位/人联系电话 -->
              <div class="form-row">
                <label class="form-label required">成果持有单位/人联系电话:</label>
                <el-form-item prop="phoneNumber">
                  <el-input type="text" class="form-input" placeholder="请输入成果持有单位/人联系电话"
                            v-model="form.phoneNumber"/>
                </el-form-item>
              </div>
              <!-- 所属区县 -->
              <div class="form-row">
                <label class="form-label required">所属区县:</label>
                <el-form-item prop="areaCodeval">
                  <select id="areaCodeval" class="form-input" v-model="form.areaCodeval"
                          @change="updateAreaCode(form.areaCodeval)">
                    <option value="" disabled>请选择成果持有单位/人所属区县</option>
                    <option v-for="item in areaCodeArray" :value="item.value">{{ item.name }}</option>
                  </select>
                </el-form-item>
              </div>
              <!-- 完成单位/人 -->
              <div class="form-row">
                <label class="form-label required">成果完成单位/人:</label>
                <el-form-item prop="completionUnit">
                  <el-input type="text" class="form-input" placeholder="请输入成果完成单位/人(多位可用 '、' 隔开)"
                            v-model="form.completionUnit"/>
                </el-form-item>
              </div>
              <!-- 完成时间 -->
              <div class="form-row">

                <label class="form-label required">成果完成时间:</label>
                <el-form-item prop="completionTime">
                  <el-date-picker
                      v-model="form.completionTime"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      @change="handleDateChange"
                  />
                </el-form-item>
              </div>

              <!-- 技术领域 -->
              <div class="rights-section">
                <label class="form-label required">成果技术领域:</label>
                <el-form-item prop="technicalField">
                  <div class="rights-grid">
                    <div class="right-optionValue" v-for="right in technicalFieldList" :key="right">
                      <input type="radio" :value="right" v-model="technicalFieldSelected" @change="handleTechnicalFieldChange">
                      <label>{{ right }}</label>
                    </div>
                  </div>
                  <div class="technical-field-other" v-if="technicalFieldSelected === '其他'">
                    <input
                        class="form-input"
                        placeholder="请输入成果技术领域"
                        v-model="technicalFieldOther"
                        maxlength="50"
                        @input="handleTechnicalFieldChange"
                    />
                  </div>
                </el-form-item>
              </div>

              <!-- 成果价值评估：自我估值、专家估值、综合估值同时展示 -->
              <div class="rights-section">
                <label class="form-label required">成果价值评估:</label>
              </div>

              <!-- 自我估值 -->
              <div class="valuation-type-section">
                <div class="valuation-type-title">自我估值（包括企业自行寻找专家的评估估值）</div>
                <div class="form-row">
                  <el-form-item prop="money">
                    <label class="form-label required">成果金额(万元):</label>
                    <input class="form-input" placeholder="请输入金额" v-model="form.money"/>
                  </el-form-item>
                </div>
              </div>

              <div class="form-row">
                <label class="form-label">上传自我评估证明材料:</label>
                <el-form-item prop="evaluateSupportingMaterials">
                  <div class="file-upload">
                    <el-upload
                        class="upload-demo"
                        drag
                        :file-list="assessmentList"
                        :action="UPLOAD_IMAGE_URL"
                        :headers="uploadHeaders"
                        :accept="UPLOAD_ACCEPT"
                        :before-upload="beforeUploadAuth"
                        multiple
                        :on-success="handleUploadAssessment"
                        :on-remove="handleFileRemoveAssessment"
                        :on-preview="previewUploadFile"
                        :limit="1"
                        :on-exceed="determineUniqueness"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__tip" slot="tip">文件大小不得超过50MB</div>
                    </el-upload>
                  </div>
                </el-form-item>
              </div>
              <div v-if="!isAdminEditMode" class="expert-delegate-wrap">
                <div class="expert-delegate-entry" @click="handleExpertClick">
                  <span class="form-label expert-delegate-link-wrap">
                    委托科技大市场<span class="clickable">专家评估</span>
                  </span>
                </div>
                <div class="expert-delegate-gap" style="display: block; height: 48px; min-height: 48px;" aria-hidden="true"></div>
              </div>
              <!-- 专家估值（管理员修改时展示） -->
              <template v-if="isAdminEditMode">
                <div class="valuation-type-section">
                  <div class="valuation-type-title">科技大市场专家估值</div>
                  <div class="form-row">
                    <el-form-item prop="expertValuation">
                      <label class="form-label">专家估值金额(万元):</label>
                      <input class="form-input" placeholder="请输入专家估值金额" v-model="form.expertValuation"/>
                    </el-form-item>
                  </div>
                  <div class="form-row">
                    <label class="form-label">上传专家评估材料:</label>
                    <div class="file-upload">
                      <el-upload
                          class="upload-demo"
                          drag
                          :file-list="comprehensiveAssessmentList"
                          :action="UPLOAD_IMAGE_URL"
                          :headers="uploadHeaders"
                          :accept="UPLOAD_ACCEPT"
                          :before-upload="beforeUploadAuth"
                          :on-success="handleUploadComprehensiveAssessment"
                          :on-remove="handleFileRemoveComprehensiveAssessment"
                          :on-preview="previewUploadFile"
                          :limit="1"
                          :on-exceed="determineUniqueness"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">文件大小不得超过50MB</div>
                      </el-upload>
                    </div>
                  </div>
                </div>

                <!-- 综合估值 -->
                <div class="valuation-type-section">
                  <div class="valuation-type-title">
                    综合估值
                    <span class="optional-tag">（选填）</span>
                  </div>
                  <div class="form-row">
                    <el-form-item prop="comprehensiveEvaluation">
                      <label class="form-label">综合成果估值金额(万元):</label>
                      <input class="form-input" placeholder="请输入综合估值金额(万元)"
                             v-model="form.comprehensiveEvaluation"/>
                    </el-form-item>
                  </div>
                </div>
              </template>

              <!-- 成果介绍 -->
              <div class="form-row">
                <label class="form-label required">成果介绍:</label>
                <el-form-item prop="introductionAchievements">
                  <el-input type="textarea" show-word-limit :maxlength="100" class="form-input"
                            placeholder="请输入成果介绍（最多100个字）" v-model="form.introductionAchievements"
                            @input="handleSingleLineTextInput('introductionAchievements', $event)"
                            @keydown.native="preventTextareaEnter"/>
                </el-form-item>
              </div>

              <!-- 核心技术 -->
              <div class="form-row">
                <label class="form-label required">成果核心技术:</label>
                <el-form-item prop="coreTechnology">
                  <el-input type="textarea" class="form-input" placeholder="请输入成果核心技术(最多100个字)"
                            show-word-limit
                            :maxlength="100" v-model="form.coreTechnology"
                            @input="handleSingleLineTextInput('coreTechnology', $event)"
                            @keydown.native="preventTextareaEnter"/>
                </el-form-item>
              </div>

              <div class="form-row">
                <label class="form-label required">成果场景应用:</label>
                <el-form-item prop="scenarioApplication">
                  <el-input type="textarea"
                            class="form-input"
                            placeholder="请输入成果场景应用(最多100个字)"
                            show-word-limit
                            :maxlength="100"
                            v-model="form.scenarioApplication"
                            @input="handleSingleLineTextInput('scenarioApplication', $event)"
                            @keydown.native="preventTextareaEnter"/>
                </el-form-item>
              </div>

              <div class="form-row">
                <label class="form-label required">成果市场前景:</label>
                <el-form-item prop="marketProspect">
                  <el-input type="textarea"
                            class="form-input"
                            placeholder="请输入成果市场前景(最多100个字)"
                            show-word-limit
                            :maxlength="100"
                            v-model="form.marketProspect"
                            @input="handleSingleLineTextInput('marketProspect', $event)"
                            @keydown.native="preventTextareaEnter"/>
                </el-form-item>

              </div>
              <!-- 转化方式 -->
              <div class="rights-section">
                <label class="form-label required">成果转化方式:</label>
                <el-form-item prop="allSelected">
                  <div class="rights-grid">
                    <div class="right-option">
                      <input type="checkbox" id="all" name="rights" value="all" v-model="allSelected"
                             @change="toggleAll">
                      <label for="all">全选</label>
                    </div>
                    <div class="right-option" v-for="right in rights" :key="right">
                      <input type="checkbox" :value="right" v-model="selectedRights">
                      <label>{{ right }}</label>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div class="form-row">
                <label class="form-label required">上传成果评价材料或者其他材料（非核心技术材料）:</label>
                <el-form-item prop="uploadFiles">
                  <div class="file-upload">
                    <div>
                      <el-upload
                          class="upload-demo"
                          drag
                          :limit="1"
                          :file-list="formattedFileList"
                          :action="UPLOAD_IMAGE_URL"
                          :headers="uploadHeaders"
                          :accept="UPLOAD_DOCUMENT_ACCEPT"
                          :before-upload="beforeUploadDocument"
                          :on-success="handleUploadSuccess"
                          :on-remove="handleFileRemove"
                          :on-preview="previewUploadFile"
                          list-type="text"

                      >
                        <i class="el-icon-upload"></i>
                        <div class="">仅支持上传单个Word、PDF或Excel文件（多文件请打包为ZIP）。请勿直接上传图片，需将图片插入Word文档后再上传。</div>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">文件大小不得超过50MB</div>
                      </el-upload>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div class="form-row">


                <label class="form-label required" >上传成果展示图片:</label>
                <el-form-item prop="uploadImg">
                  <div class="file-upload">
                    <el-upload
                        class="upload-demo"
                        drag
                        :file-list="imgList"
                        :action="UPLOAD_IMAGE_URL"
                        :headers="uploadHeaders"
                        :on-success="handleUploadimg"
                        :on-remove="handleFileRemoveImg"
                        :on-preview="previewUploadFile"
                        :limit="1"
                        :on-exceed="handleExceed"
                        ref="uploadRef"
                        accept=".jpg,.jpeg,.png,.gif,.bmp"
                        :before-upload="beforeUploadWithAuth"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__tip" slot="tip">文件大小不得超过5M</div>
                    </el-upload>

                    <div style="width:100%;text-align: center;">
                      <img :src="showimg" style="display:inline-block;text-align: center;width:20%" alt=""/>
                    </div>
                  </div>
                </el-form-item>
              </div>

              <div class="btn-bar">
                <!-- 文件类型说明 -->
                <div class="submitClass" v-if="temporarilyShow === 0">
                  <div class="submit-buttonLeft" @click="temporarilyStore()">
                    <span class="temp-store-main"><i class="el-icon-folder-add"></i> 暂存</span>
                    <span class="temp-store-tip">（暂存记录请去我的查看）</span>
                  </div>
                  <div class="submit-buttonRight" @click="homeviewSubmit('rules')">
                    <i class="el-icon-upload2"></i> 立即存证
                  </div>
                </div>

                <div class="submitClass" v-else-if="temporarilyShow === 1">
                  <div class="submit-buttonLeft" @click="updateTemporarilyById()">
                    <span class="temp-store-main"><i class="el-icon-folder-add"></i> 暂存</span>
                    <span class="temp-store-tip">（暂存记录请去我的查看）</span>
                  </div>
                  <div class="submit-buttonRight" @click="temporaryCertificatesAdd('rules')">
                    <i class="el-icon-upload2"></i> 立即存证
                  </div>
                  <div>
                  </div>
                </div>


                <div class="submitClass" v-else-if="temporarilyShow === 2">
                  <el-button class="changeEvidence" :loading="changeEvidenceSaving" @click="changeEvidence">
                    <i class="el-icon-edit"></i> 保存并更新证书
                  </el-button>
                </div>

                <div class="submitClass" v-else-if="temporarilyShow === 3">
                  <el-button class="changeEvidence" :loading="resubmitEvidenceSaving" @click="resubmitEvidenceForm('rules')">
                    <i class="el-icon-upload2"></i> 保存并重新提交
                  </el-button>
                </div>
              </div>
            </el-form>
          </div>

          <div class="cha_xun" v-if="queryHash">
            <div class="tips" data-v-71571416>

              <div class="tipMessage">
                证书核验<br data-v-71571416/>
                文件哈希值是区块链上存证的唯一标识，您可以核验您所持证据是否运用区块链技术已同步存储在泰山区块链。
              </div>

            </div>
            <div class="input_box" data-v-71571416>
              <div class="unified_numbering" data-v-71571416>
                <div class="filed" data-v-71571416>
                  <div class="querytext">证书编号:</div>
                </div>

                <div class="el-input">
                  <input
                      type="text"
                      v-model="certificateNo"
                      autocomplete="off"
                      placeholder="请输入证书编号"
                      class="el-input__inner"
                  />
                </div>

              </div>
              <div class="file_hash" data-v-71571416>
                <div class="filed" data-v-71571416>
                  <div class="querytext">文件哈希:</div>
                </div>
                <div class="el-input" data-v-71571416>
                  <input
                      type="text"
                      v-model="hashValue"
                      autocomplete="off"
                      placeholder="请输入文件哈希"
                      class="el-input__inner"
                  />
                </div>
              </div>
              <div class="query" @click="queryHashData()" data-v-71571416>查询核验</div>
            </div>
          </div>
          <div class="me" v-if="showInfo">
            <PersonalInformation @updateMessage="updateParentMessage" @changeMessage="userResubmitMessage"/>
          </div>
          <!---管理员走这个--->
          <div class="me" v-if="showInfoAdmin">
            <InformationAdmin @updateMessage="updateParentMessage" @changeMessage="changeParentMessage"/>
          </div>
          <!--二级管理员-->
          <div class="me" v-if="unitAdmin">
            <MySecondLevel @updateMessage="updateParentMessage" @changeMessage="changeParentMessage" @userResubmit="userResubmitMessage"/>
          </div>


          <div class="imgSh" v-if="imgShow">
            <div>
              <img class="imgSh"
                   style="height: 60%; width: 60%" :src="certificateUrl" alt/>
            </div>
          </div>

          <!---下面背景图 -->
          <div style="background: #252525">
            <img
                src="../assets/img/c02ddf2d50ba0a9c37c54f6b278d02a.png"
                alt
                class="foot_bg"
            />
            <div class="website">
              <div class="max_wid">
                <div class="max_lef">

                  <div class="labe2">
                    通讯地址：泰安市高新区正阳门大街28号国家高创中心西塔422号
                  </div>
                  <div class="classLabe2">
                    <div class="labe2Left">
                      主办单位：泰山科技大市场
                    </div>
                    <div class="labe2Right">
                      <div class="view-pill">
                        <i class="el-icon-view view-icon"></i>
                        <span class="view-text">{{ viewCount }} 浏览</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="max_rig">
                  <div class="labe2">联系方式：18953878448</div>
                  <div class="labe2">邮编：271000</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :visible.sync="isExpertDialogVisible"
        title="委托专家评估"
        width="40%"
    >

      <el-form :model="expertForm" ref="rulesFrom" :rules="rulesFrom" label-width="150px">
        <el-form-item label="委托人单位" prop="principalNit">
          <el-input v-model="expertForm.principalNit" placeholder="请输入单位名称"/>
        </el-form-item>
        <el-form-item label="委托人姓名" prop="client">
          <el-input v-model="expertForm.client" placeholder="请输入姓名"/>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactInformation">
          <el-input v-model="expertForm.contactInformation" placeholder="请输入联系电话"/>
        </el-form-item>
        <el-form-item label="其他备注">
          <el-input
              type="textarea"
              v-model="expertForm.notes"
              placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="subclass" type="primary" @click="submitExpertForm('rulesFrom')">提交</el-button>
        <el-button class="closeClass" type="warning" @click="closeExpertDialog">取消</el-button>
      </div>

    </el-dialog>
    <div>
    </div>
    <div>
    </div>

    <div>
      <!-- 用户导入对话框 -->
      <el-dialog :title="upload.title" :visible.sync="upload.open" append-to-body>
        <el-upload ref="upload" :limit="1" accept=".xlsx, .xls" :headers="upload.headers" :action="upload.url"
                   :disabled="upload.isUploading" :on-progress="handleFileUploadProgress"
                   :on-success="handleFileSuccess" :auto-upload="false" drag>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>

          <span>仅允许导入xls、xlsx格式文件。</span>
        </el-upload>
        <div slot="footer" class="dialog-footer">
          <el-button type="success" @click="importTemplate">下载模板</el-button>
          <el-button type="primary" @click="submitFileForm">确 定</el-button>

          <el-button @click="upload.open = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>

<!--    <div class="guide-video-fab" @click="openGuideVideo" title="观看操作视频">-->
<!--      <i class="el-icon-video-play"></i>-->
<!--      <span class="guide-video-fab__text">操作视频</span>-->
<!--    </div>-->

    <el-dialog
        title="存证操作视频"
        :visible.sync="guideVideoVisible"
        width="860px"
        top="8vh"
        append-to-body
        destroy-on-close
        custom-class="guide-video-dialog"
        @close="handleGuideVideoClose"
    >
      <div v-if="homeGuideVideoUrl" class="guide-video-wrap">
        <video
            ref="guideVideoPlayer"
            class="guide-video-player"
            :key="homeGuideVideoUrl"
            :src="homeGuideVideoUrl"
            controls
            controlslist="nodownload"
            preload="metadata"
            playsinline
        >
          您的浏览器不支持视频播放
        </video>
      </div>
      <div v-else class="guide-video-empty">
        暂未配置操作视频，请将视频文件放到 public/video/ 目录并命名为 home-guide.mp4
      </div>
    </el-dialog>
  </div>

</template>
<script>

import InformationAdmin from "@/views/InformationAdmin.vue";
import {certificateQuery, resubmitEvidence} from "@/api/certificate";
import {
  commissionAdd,
  uploadImg,
  temporarily,
  temporarilyById,
  updateTemporarily,
  temporaryCertificates,
  evidenceById,
  changeEvidence,
  visit
} from "@/api/http";
import {evidence, getInfo} from "@/api/login";
import MySecondLevel from "@/views/secondInstance/mySecondLevel.vue";
import PersonalInformation from "@/views/PersonalInformation .vue";
import {normalizeSingleLineText} from "@/utils/validate";
import { getUploadHeaders, UPLOAD_IMAGE_URL, UPLOAD_ACCEPT, UPLOAD_DOCUMENT_ACCEPT, beforeUploadAuth, parseUploadResponse, promptReLogin, getStoredToken, isImageFile, getFileBaseName, buildUploadFileList, previewUploadFile, resolveFileUrl } from "@/config/upload";

export default {
  components: {PersonalInformation, MySecondLevel, InformationAdmin},
  data() {
    return {
      UPLOAD_IMAGE_URL,
      UPLOAD_ACCEPT,
      UPLOAD_DOCUMENT_ACCEPT,
      beforeUploadAuth,
      numberFile:1,
      //判断是否为二级管理
      unitAdmin: false,
      //是否为管理员
      showAdmin: false,
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: {Authorization: "Bearer " + localStorage.getItem("token")},
        // 上传地址在 handleImport 时按当前 userId 动态设置
        url: '',
      },

      //判断是否是暂存
      temporarilyShow: 0,
      changeEvidenceSaving: false,
      resubmitEvidenceSaving: false,
      //展示图片名字
      handleUploadimgUrl: '',
      expertForm: {
        notes: "",
        name: "",
        phone: "",
        contactInformation: "",
        principalNit: ""
      },
      showInfoAdmin: false,
      isExpertDialogVisible: false,
      certificateNo: '',
      hashValue: '',
      imgShow: false,
      loginTrue: false,
      showPage: true,
      formShow: false,
      queryHash: false,
      showInfo: false,
      certificateUrl: false,
      uploadFiles: "",
      uploadImg: "",
      showimg: "",

      form: {
        handleUploadimgUrl: "",
        completePhoneNumber: "",//完成单位/人
        achievementName: "",//成果名称
        holdingUnit: "",//持有单位/人
        completionUnit: "",//完成单位/人
        phoneNumber: "", //联系电话
        completionTime: "",//完成时间
        introductionAchievements: "",//成果介绍
        coreTechnology: "",//核心技术
        marketProspect: "",//市场前景
        money: "",//金额
        //旧的
        depositSubject: "", // 存证主体
        isThirdParty: false, // 是否为第三方机构
        author: "", // 作者
        authorId: "", // 作者证件
        authorIdNumber: "", // 作者证件号码
        memberId: "", // 会员编号
        uploadFiles: "", // 上传文件
        depositName: "", // 存证名称
        depositType: "", // 存证类型
        equityOwnership: [], // 权益拥有
        originalFilenameUrl: "",//文件上传路径
        evaluationDocuments: "",//委托/专家评估文件（历史字段）
        evaluateSupportingMaterials: "",//自我估值证明材料
        evaluateSupportingMaterialsName: "",//自我估值证明材料文件名（展示用）
        originalFilenameUrlName: "",//评估证书名
        //价值评估类型（提交时写入，用于兼容历史展示）
        valueAssessment: "",
        //技术领域
        technicalField: "",
        //自我成果估值
        selfValuation: "",
        uploadImg: "",
        areaCodeval: "",
        expertEvaluation: "",
        //综合估值金额
        comprehensiveEvaluation: "",
        //专家估值金额
        expertValuation: "",
        //综合估值-专家评估材料（文件名）
        comprehensiveEvaluationFileName: "",
        //综合估值-专家评估材料（路径）
        comprehensiveEvaluationFileUrl: "",
        //专家成果估值材料文件路径
        expertValuationMaterialUrl: "",
      },

      cache: {
        handleUploadimgUrl: "",
        achievementName: "",//成果名称
        holdingUnit: "",//持有单位/人
        completionUnit: "",//完成单位/人
        phoneNumber: "", //联系电话
        completionTime: "",//完成时间
        introductionAchievements: "",//成果介绍
        coreTechnology: "",//核心技术
        marketProspect: "",//市场前景
        money: "",//金额
        //旧的
        depositSubject: "", // 存证主体
        isThirdParty: false, // 是否为第三方机构
        author: "", // 作者
        authorId: "", // 作者证件
        authorIdNumber: "", // 作者证件号码
        memberId: "", // 会员编号
        uploadFiles: "", // 上传文件
        depositName: "", // 存证名称
        depositType: "", // 存证类型
        equityOwnership: [], // 权益拥有
        originalFilenameUrl: "",//文件上传路径
        evaluationDocuments: "",//委托/专家评估文件（历史字段）
        evaluateSupportingMaterials: "",//自我估值证明材料
        evaluateSupportingMaterialsName: "",//自我估值证明材料文件名（展示用）
        originalFilenameUrlName: "",//评估证书名
        //价值评估类型（提交时写入，用于兼容历史展示）
        valueAssessment: "",
        //自我成果估值
        selfValuation: "",
        //综合估值金额
        comprehensiveEvaluation: "",
        //专家估值金额
        expertValuation: "",
        //综合估值-专家评估材料
        comprehensiveEvaluationFileName: "",
        comprehensiveEvaluationFileUrl: "",
        //专家成果估值材料文件路径
        expertValuationMaterialUrl: "",
        //技术领域
        technicalField: "",
      },

      commission: {
        notes: "",
        name: "",
        phone: "",
        userId: ""
      },


      commissionClean: {
        notes: "",
        name: "",
        phone: "",
        userId: ""
      },
      userId: 0,
      isIndeterminate: false, // 全选状态控制
      checkedCities: [], // 选择的城市列表
      value: "",
      value1: "",
      value2: "",
      rights: [
        "自行实施转化",
        "科技成果转让",
        "科技成果许可",
        "合作实施转化",
        "科技成果作价投资",
        "其他",
      ],
      technicalFieldList: [
        "新一代信息技术产业",
        "高端装备制造产业",
        "新材料产业",
        "生物产业",
        "新能源汽车产业",
        "新能源产业",
        "节能环保产业",
        "数字创意产业",
        "相关服务业",
        "现代食品产业",
        "现代农林渔产业",
        " 医药及医疗器械产业",
        "其他",
      ],
      allSelected: false,
      selectedRights: [],
      technicalFieldSelected: "",
      technicalFieldOther: "",
      areaCodeArray: [
        {value: 370902, name: "泰山区"},
        {value: 370911, name: "岱岳区"},
        {value: 370971, name: "高新区"},
        {value: 370983, name: "肥城市"},
        {value: 370982, name: "新泰市"},
        {value: 370921, name: "宁阳县"},
        {value: 370923, name: "东平县"},
        {value: -1, name: "其他地区"},
      ],
      rulesFrom: {
        principalNit: [{required: true, message: "委托人单位不能为空", trigger: "blur"}],
        client: [{required: true, message: "委托人姓名不能为空", trigger: "blur"}],
        contactInformation: [{required: true, message: '联系电话不能为空', trigger: 'blur'}]
      },
      rules: {
        achievementName: [{required: true, message: '请输入成果名称', trigger: 'blur'}],
        holdingUnit: [{required: true, message: '请输入持有单位/人', trigger: 'blur'}],
        areaCodeval: [{required: true, message: '请选择所属区县', trigger: 'change'}],
        completionUnit: [{required: true, message: '请输入完成单位/人', trigger: 'blur'}],
        phoneNumber: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
        completionTime: [{required: true, message: '请选择完成时间', trigger: 'blur'}],
        technicalField: [{required: true, message: '请选择或输入成果技术领域', trigger: 'change'}],
        money: [{required: true, message: '请输入自我估值成果金额', trigger: 'blur'}],
        introductionAchievements: [
          {required: true, message: '请输入成果介绍', trigger: 'blur'},
          {min: 20, max: 100, message: '成果介绍长度需在20到100个字之间', trigger: 'blur'}
        ],
        coreTechnology: [{required: true, message: '请输入核心技术', trigger: 'blur'},
          {min: 20, max: 100, message: '核心技术长度需在20到100个字之间', trigger: 'blur'}
        ],
        scenarioApplication: [{required: true, message: '请输入应用场景', trigger: 'blur'},
          {min: 20, max: 100, message: '应用场景长度需在20到100个字之间', trigger: 'blur'}],
        marketProspect: [{required: true, message: '请输入市场前景', trigger: 'blur'},
          {min: 20, max: 100, message: '市场前景长度需在20到100个字之间', trigger: 'blur'}],
        // allSelected:[{required: true, message: '请输入转化方式', trigger: 'blur'}],
        uploadImg: [{required: true, message: '请上传图片', trigger: 'blur'}],
        uploadFiles: [{required: true, message: '请上传成果证明材料', trigger: 'blur'}],
      },
      // 浏览量
      viewCount: 0,
      guideVideoVisible: false,
      homeGuideVideoUrl: 'https://tskjdsc.com/statics/vido/dsczpt.mp4',
    };

  },
  created() {
    //获取暂存数据
    this.queryLocalStorage()
    // 初始化首页浏览量
    this.initViewCount()
    if (localStorage.getItem('token')) {
      this.loginTrue = true
      this.showPage = true
    } else {
      this.loginTrue = false
    }
  },
  computed: {

    uploadHeaders() {
      return getUploadHeaders()
    },

    /** 管理员从审核通过列表点「修改」进入的编辑模式 */
    isAdminEditMode() {
      return this.temporarilyShow === 2
    },

    // 将 uploadFiles 转为 el-upload 展示列表（不在 computed 里弹窗）
    formattedFileList() {
      return buildUploadFileList(this.form.uploadFiles, this.form.originalFilenameUrl)
    },

    assessmentList() {
      return buildUploadFileList(this.form.evaluateSupportingMaterials, this.form.evaluateSupportingMaterialsName)
    },

    comprehensiveAssessmentList() {
      return buildUploadFileList(this.form.comprehensiveEvaluationFileUrl, this.form.comprehensiveEvaluationFileName)
    },

    imgList() {
      const paths = this.form.handleUploadimgUrl || this.form.uploadImg
      return buildUploadFileList(paths, '')
    }
  },

  watch: {
    selectedRights(newVal) {
      this.form.equityOwnership = newVal;
    }
  },

  methods: {
    previewUploadFile,

    //跳转成果库
    jumpToResultsLibrary(){
      window.open("https://tskjdsc.com/CertificateLibrary")
      // location.href ="http://localhost:5173/CertificateLibrary"
    },

    // 首页浏览量：调用后端接口按页面路径统计
    async initViewCount() {
      const pageKey = this.$route?.path || 'HomeView';
      try {
        const res = await visit({pageKey});
        const data = res && res.data !== undefined ? res.data : res;
        if (data && (data.code === 200 || data.code === 0)) {
          this.viewCount = data.data;
        } else if (typeof data === 'number') {
          this.viewCount = data;
        } else if (data && typeof data.data === 'number') {
          this.viewCount = data.data;
        }
      } catch (e) {
        console.error('首页浏览量上报失败', e);
      }
    },


    handleDateChange(value) {
      if (value) {
        this.form.completionTime = this.formatDate(value);
      }
    },
    formatDate(date) {
      // 转换为 'yyyy-MM-dd' 格式
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以加1
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    handleSingleLineTextInput(field, value) {
      this.form[field] = normalizeSingleLineText(value)
    },
    preventTextareaEnter(e) {
      if (e.key === 'Enter') {
        e.preventDefault()
      }
    },
    normalizeFormTextFields() {
      ['introductionAchievements', 'coreTechnology', 'scenarioApplication', 'marketProspect'].forEach(key => {
        if (this.form[key] != null) {
          this.form[key] = normalizeSingleLineText(this.form[key])
        }
      })
    },


    // 用户导入参数
    /** 导入按钮操作 */
    async handleImport() {
      if (this.form.achievementName) {
        this.cleanForm();
        this.temporarilyShow = 0
      }

      this.queryLocalStorage()
      const ok = await this.verifyLoginSession()
      if (!ok) return

      const userId = localStorage.getItem("userId")
      if (!userId) {
        this.$message.error('未获取到用户信息，请重新登录后再试')
        return
      }
      this.upload.url = `/dev-api/evidence/importData?userId=${userId}`
      this.upload.headers = getUploadHeaders()

      this.upload.title = "用户导入"
      this.upload.open = true
    },
    /** 下载模板操作 */
    importTemplate() {
      window.location.href = 'https://kejichengguo.tskjdsc.com/dev-api/evidence/download/excel'
      // window.location.href = 'http://localhost:8945/evidence/download/excel'
    },
// 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true
    },
// 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false
      this.upload.isUploading = false
      this.$refs.upload.clearFiles()
      this.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + response.msg + "</div>", "导入结果", {dangerouslyUseHTMLString: true})
      // this.getList()
    },
// 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit()
    },
    // 管理员修改成果：保存内容并重新生成证书（编号与存证时间不变）
    changeEvidence() {
      this.form.equityOwnership = this.form.equityOwnership.toString()
      this.form.conversionMethod = this.selectedRights.toString()
      this.syncValuationFields()
      this.changeEvidenceSaving = true
      changeEvidence(this.form).then(res => {
        if (res.code != null && Number(res.code) !== 200) {
          this.$message.error(res.msg || '保存失败')
          return
        }
        this.$message({
          message: res.msg || '成果内容已保存',
          type: 'success',
          duration: 3000,
          showClose: true,
          offset: 200
        })
        this.temporarilyShow = 0
        this.myInformation()
      }).catch(() => {
        this.$message.error('保存失败')
      }).finally(() => {
        this.changeEvidenceSaving = false
      })
    },

    resubmitEvidenceForm(rules) {
      this.$refs[rules].validate((valid) => {
        if (!valid) {
          this.$message.error('请检查必填项')
          return false
        }
        if (!this.validateConversionMethod()) {
          return false
        }
        this.syncValuationFields()
        this.form.equityOwnership = this.form.equityOwnership.toString()
        this.form.conversionMethod = this.selectedRights.toString()
        this.form.userId = localStorage.getItem("userId")
        const date = new Date(this.form.completionTime)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        this.form.completionTime = `${year}-${month}-${day}`
        this.resubmitEvidenceSaving = true
        resubmitEvidence(this.form).then(res => {
          if (res.code != null && Number(res.code) !== 200) {
            this.$message.error(res.msg || '提交失败')
            return
          }
          this.$message({
            message: res.msg || '修改成功，已重新提交审核',
            type: 'success',
            duration: 3000,
            showClose: true,
            offset: 200
          })
          this.cleanForm()
          this.temporarilyShow = 0
          this.myInformation()
        }).catch(() => {
          this.$message.error('提交失败')
        }).finally(() => {
          this.resubmitEvidenceSaving = false
        })
      })
    },
    //根据id获取成果
    queryByIdEvidence(id) {
      evidenceById(id).then(res => {
        if (res.code === 200) {
          if (this.temporarilyShow === 3) {
            const status = Number(res.data.auditStatus)
            if (status === 0) {
              this.$message.warning('审核中的成果不可修改，请等待审核结果')
              this.myInformation()
              return
            }
            if (status === 2) {
              this.$message.warning('该成果已审核通过，如需修改请联系管理端退回后再操作')
              this.myInformation()
              return
            }
            if (status !== 1) {
              this.$message.warning('当前状态不可修改')
              this.myInformation()
              return
            }
          }
          this.form = res.data
          this.initTechnicalFieldDisplay()
          this.selectedRights = this.form.conversionMethod ? this.form.conversionMethod.split(',') : []
          if (this.form.uploadFiles) {
            this.syncUploadFilesDisplay(this.form.uploadFiles)
          }
          this.initEvaluateSupportingMaterialsDisplay()
          this.initExpertAssessmentDisplay()
          if (this.form.uploadImg) {
            this.showimg = resolveFileUrl(this.form.uploadImg)
          }
          if (!this.form.money && this.form.selfValuation) {
            this.form.money = this.form.selfValuation
          }
          if (this.form.areaCodeval != null && this.form.areaCodeval !== '') {
            this.form.areaCodeval = Number(this.form.areaCodeval)
          }
        }
      })
    },
//修改存证信息
    changeParentMessage(message) {
      this.showPage = false;
      this.formShow = true;
      this.queryHash = false;
      this.showInfo = false;
      this.imgShow = false;
      this.showInfoAdmin = false;
      this.temporarilyShow = 2;
      this.queryByIdEvidence(message);
    },

    /** 用户从「我的」修改并重新提交 */
    userResubmitMessage(message) {
      this.showPage = false;
      this.formShow = true;
      this.queryHash = false;
      this.showInfo = false;
      this.imgShow = false;
      this.showInfoAdmin = false;
      this.unitAdmin = false;
      this.temporarilyShow = 3;
      this.queryByIdEvidence(message);
    },

    //转为存证
    temporaryCertificatesAdd(rules) {
      this.$refs[rules || 'rules'].validate((valid) => {
        if (!valid) {
          this.$message.error('请检查必填项')
          return false
        }
        if (!this.validateConversionMethod()) {
          return false
        }
        this.syncValuationFields()
        this.form.equityOwnership = this.form.equityOwnership.toString()
        this.form.conversionMethod = this.selectedRights.toString()
        this.form.userId = localStorage.getItem("userId")
        const date = new Date(this.form.completionTime)

        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        this.form.completionTime = `${year}-${month}-${day}`
        temporaryCertificates(this.form).then(res => {
          if (res.code === 200) {
            this.cleanForm()
            this.$message({
              message: '存证成功，请耐心等待审核',
              type: 'success',
              duration: 3000,
              showClose: true,
              offset: 200
            })
          }
        })
      })
    },

    //子组件获取的消息
    updateParentMessage(newMessage) {
      // this.message = newMessage;
      this.showPage = false;
      this.formShow = true;
      this.queryHash = false;
      this.showInfo = false;
      this.imgShow = false;
      this.showInfoAdmin = false;
      this.temporarilyShow = 1;
      this.temporarilyById(newMessage);
    },

    //根据id获取相应的暂存
    temporarilyById(id) {
      temporarilyById(id).then(res => {
        if (res.code === 200) {
          this.form = res.data;
          this.normalizeFormTextFields();
          this.initTechnicalFieldDisplay()
          this.selectedRights = res.data.conversionMethod.split(',')
          this.syncUploadFilesDisplay(this.form.uploadFiles)
          this.showimg = resolveFileUrl(this.form.uploadImg)
          this.form.handleUploadimgUrl = this.form.uploadImg
          this.initEvaluateSupportingMaterialsDisplay()
        }

      })
      this.imgList();
    },

    /** 根据 uploadFiles 路径同步展示用文件名 */
    syncUploadFilesDisplay(uploadFiles) {
      if (!uploadFiles) {
        this.form.originalFilenameUrl = ''
        this.form.originalFilenameUrlName = ''
        return
      }
      const displayNames = String(uploadFiles).split(',').map(path => getFileBaseName(path)).join(',')
      this.form.originalFilenameUrl = displayNames
      this.form.originalFilenameUrlName = displayNames
    },

    beforeUploadDocument(file) {
      if (!beforeUploadAuth(file)) {
        return false
      }
      if (isImageFile(file.name)) {
        this.$message.error('只能上传文件材料，不能上传照片！如需上传图片，请插入 Word 文档后再上传。')
        return false
      }
      return true
    },

    //修改暂存
    updateTemporarilyById() {
      this.$refs.rules.validate((valid) => {
        if (!valid) {
          this.$message.error('请检查必填项')
          return false
        }
        if (!this.validateConversionMethod()) {
          return false
        }
        this.syncValuationFields()
        this.form.equityOwnership = this.form.equityOwnership.toString()
        this.form.conversionMethod = this.selectedRights.toString()
        this.form.userId = localStorage.getItem("userId")
        updateTemporarily(this.form).then(res => {
          if (res.code === 200) {
            this.cleanForm()
            this.showimg = ""
            localStorage.removeItem('formData')
            this.$message({
              message: '修改暂存成功，请去右上角我的——暂存记录查看',
              type: 'success',
              duration: 3000,
              showClose: true,
              offset: 200
            })
          } else {
            this.$message.error('修改暂存失败')
          }
        }).catch(() => {
          this.$message.error('修改暂存异常')
        })
      })
    },
    beforeUploadWithAuth(file) {
      if (!beforeUploadAuth(file)) {
        return false
      }
      return this.beforeUpload(file)
    },
    beforeUpload(file) {
      const isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPGorPNG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isJPGorPNG && isLt5M;
    },
    // 更新 form.areaCode 的值
    updateAreaCode(selectElement) {
      this.form.areaCodeval = selectElement;
      console.log('Selected area code:', this.form.areaCode);
    },

    //判断是否为管理员
    isAdmin() {
      const userId = localStorage.getItem("userId");
      console.log("userIdsss", userId);
      this.showAdmin = userId === '1';
      console.log("localStorage.getItem(\"userId\")", localStorage.getItem("userId"))
      console.log(" this.showAdmin", this.showAdmin)
    },

    handleFileRemoveAssessment(data) {
      const removeAtIndex = (field) => {
        if (!this.form[field]) return
        const fileArray = this.form[field].split(',')
        fileArray.splice(data.uid, 1)
        this.form[field] = fileArray.join(',')
      }
      removeAtIndex('evaluateSupportingMaterialsName')
      removeAtIndex('evaluateSupportingMaterials')
      this.$nextTick(() => {
        this.$refs.rules && this.$refs.rules.validateField('evaluateSupportingMaterials')
      })
    },

    /** 从 evaluateSupportingMaterials 解析文件名用于文件列表展示 */
    initEvaluateSupportingMaterialsDisplay() {
      const materials = this.form.evaluateSupportingMaterials
      if (!materials) {
        this.form.evaluateSupportingMaterialsName = ''
        return
      }
      this.form.evaluateSupportingMaterialsName = materials.split(',').map(url => {
        const parts = url.split(/[\\/]/)
        return parts[parts.length - 1]
      }).join(',')
    },

    /** 专家评估材料文件名回显（管理员编辑） */
    initExpertAssessmentDisplay() {
      if (this.form.comprehensiveEvaluationFileName) {
        return
      }
      const url = this.form.comprehensiveEvaluationFileUrl || this.form.expertValuationMaterialUrl
      if (!url) {
        return
      }
      if (!this.form.comprehensiveEvaluationFileUrl) {
        this.form.comprehensiveEvaluationFileUrl = url
      }
      this.form.comprehensiveEvaluationFileName = url.split(',').map(item => {
        const parts = item.split(/[\\/]/)
        return parts[parts.length - 1]
      }).join(',')
    },

    //自我估值证明材料上传
    handleUploadAssessment(response) {
      const result = parseUploadResponse(response)
      if (!result.ok) {
        if (result.expired) promptReLogin()
        else this.$message.error(result.msg)
        return
      }
      const data = result.data
      this.form.evaluateSupportingMaterials = this.form.evaluateSupportingMaterials ?
          this.form.evaluateSupportingMaterials + ',' + data.newName :
          data.newName

      this.form.evaluateSupportingMaterialsName = this.form.evaluateSupportingMaterialsName ?
          this.form.evaluateSupportingMaterialsName + ',' + data.originalFilename :
          data.originalFilename
      this.$nextTick(() => {
        this.$refs.rules && this.$refs.rules.validateField('evaluateSupportingMaterials')
      })
    },

    //综合估值-专家评估材料上传
    handleUploadComprehensiveAssessment(response) {
      const result = parseUploadResponse(response)
      if (!result.ok) {
        if (result.expired) promptReLogin()
        else this.$message.error(result.msg)
        return
      }
      const data = result.data
      this.form.comprehensiveEvaluationFileUrl = this.form.comprehensiveEvaluationFileUrl ?
          this.form.comprehensiveEvaluationFileUrl + ',' + data.newName :
          data.newName

      this.form.comprehensiveEvaluationFileName = this.form.comprehensiveEvaluationFileName ?
          this.form.comprehensiveEvaluationFileName + ',' + data.originalFilename :
          data.originalFilename

      this.form.expertValuationMaterialUrl = this.form.expertValuationMaterialUrl ?
          this.form.expertValuationMaterialUrl + ',' + data.newName :
          data.newName
    },

    //综合估值-专家评估材料删除
    handleFileRemoveComprehensiveAssessment(data) {
      const fileArray = this.form.comprehensiveEvaluationFileName.split(',');
      fileArray.splice(data.uid, 1);
      this.form.comprehensiveEvaluationFileName = fileArray.join(',');

      const urlArray = this.form.comprehensiveEvaluationFileUrl.split(',');
      urlArray.splice(data.uid, 1);
      this.form.comprehensiveEvaluationFileUrl = urlArray.join(',');

      const materialUrlArray = this.form.expertValuationMaterialUrl.split(',');
      materialUrlArray.splice(data.uid, 1);
      this.form.expertValuationMaterialUrl = materialUrlArray.join(',');
    },


    handleFileRemove(data) {
      this.form.uploadFiles = ''
      this.form.originalFilenameUrl = ''
    },

    //存证文件
    handleUploadSuccess(response) {
      const result = parseUploadResponse(response)
      if (!result.ok) {
        if (result.expired) promptReLogin()
        else this.$message.error(result.msg)
        return
      }
      const data = result.data
      this.form.uploadFiles = data.newName
      this.form.originalFilenameUrl = data.originalFilename
    },

    //展示图片
    handleUploadimg(response) {
      const result = parseUploadResponse(response)
      if (!result.ok) {
        if (result.expired) promptReLogin()
        else this.$message.error(result.msg)
        return
      }
      this.showimg = result.data.newName
      this.form.uploadImg = result.data.newName
    },


    handleFileRemoveImg(data) {
      this.showimg = "";
    },
    determineUniqueness(files, fileList) {
      this.$message.warning('只能上传一次，请先移除现有的在上传新的文件');
    },
    handleExceed(files, fileList) {
      // 当超过文件限制时的处理
      this.$message.warning('只能上传一个图片，请先移除已有的图片再上传新的图片');
    },

    //委托弹窗提交
    submitExpertForm(rulesFrom) {
      this.$refs[rulesFrom].validate((valid) => {
        if (valid) {
          this.commission = this.expertForm;
          this.commission.userId = localStorage.getItem("userId")
          commissionAdd(this.commission).then(res => {
            console.log("res", res);
            if (res.code === 200) {
              this.$message({
                message: '您的委托已提交，请等待',
                type: 'success',
                duration: 3000,
                showClose: true,
                offset: 200
              })
            }
          })
          this.expertForm = this.commissionClean;
          this.isExpertDialogVisible = false
        } else {
          this.$message.error('请检查必填的数据');
          return false;
        }
      })
    },

    //弹窗取消操作
    closeExpertDialog() {
      this.isExpertDialogVisible = false
    },
    handleExpertClick() {
      this.isExpertDialogVisible = true
    },
    handleTechnicalFieldChange() {
      if (this.technicalFieldSelected !== '其他') {
        this.form.technicalField = this.technicalFieldSelected
        this.technicalFieldOther = ''
      } else {
        this.form.technicalField = (this.technicalFieldOther || '').trim()
      }
      this.$nextTick(() => {
        this.$refs.rules && this.$refs.rules.validateField('technicalField')
      })
    },
    initTechnicalFieldDisplay() {
      const value = (this.form.technicalField || '').trim()
      if (!value) {
        this.technicalFieldSelected = ''
        this.technicalFieldOther = ''
        return
      }
      const matched = this.technicalFieldList.find(item => item.trim() === value)
      if (matched) {
        this.technicalFieldSelected = matched
        this.technicalFieldOther = ''
      } else {
        this.technicalFieldSelected = '其他'
        this.technicalFieldOther = value
      }
    },
    /** 提交前同步估值字段（自我估值必填；专家/综合估值选填） */
    syncValuationFields() {
      this.handleTechnicalFieldChange()
      this.normalizeFormTextFields()
      this.form.selfValuation = this.form.money || this.form.selfValuation || ''
      const hasExpert = !!(this.form.expertValuation && String(this.form.expertValuation).trim())
      const hasComprehensive = !!(this.form.comprehensiveEvaluation && String(this.form.comprehensiveEvaluation).trim())
      if (this.isAdminEditMode) {
        if (hasExpert && hasComprehensive) {
          this.form.valueAssessment = '3'
        } else if (hasExpert) {
          this.form.valueAssessment = '2'
        } else {
          this.form.valueAssessment = '1'
        }
        return
      }
      if (hasExpert && hasComprehensive) {
        this.form.valueAssessment = '3'
      } else {
        this.form.valueAssessment = '1'
      }
    },
    //获取暂存数据
    queryLocalStorage() {
      var item = localStorage.getItem("formData");
      console.log("item", item);
      if (item !== undefined && item != null) {
        this.form = JSON.parse(localStorage.getItem("formData"));
        this.normalizeFormTextFields();
        this.initTechnicalFieldDisplay()
        console.log("this.form", this.form);
        this.selectedRights = localStorage.getItem("selectedRights").split(',')
        this.form.valueAssessment = '3'
        if (!this.form.selfValuation && this.form.money) {
          this.form.selfValuation = this.form.money
        }
      } else {

      }
    },

    /** 校验成果转化方式（未绑定 el-form-item，需单独判断） */
    validateConversionMethod() {
      if (!this.selectedRights || this.selectedRights.length === 0) {
        this.$message.error('请选择成果转化方式')
        return false
      }
      return true
    },
    /** 执行暂存提交 */
    submitTemporarilyData() {
      this.syncValuationFields()
      this.form.equityOwnership = this.form.equityOwnership.toString()
      this.form.conversionMethod = this.selectedRights.toString()
      this.form.userId = localStorage.getItem("userId")
      temporarily(this.form).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '暂存成功，请去右上角我的——暂存记录查看',
            type: 'success',
            duration: 3000,
            showClose: true,
            offset: 200
          })
          this.cleanForm()
          this.showimg = ""
          localStorage.removeItem('formData')
        } else {
          this.$message.error('暂存失败')
        }
      }).catch(() => {
        this.$message.error('暂存异常')
      })
    },
    //暂存功能（与立即存证相同，先校验必填项）
    temporarilyStore() {
      this.$refs.rules.validate((valid) => {
        if (!valid) {
          this.$message.error('请检查必填项')
          return false
        }
        if (!this.validateConversionMethod()) {
          return false
        }
        this.submitTemporarilyData()
      })
    },


    //退出操作，清空token
    logout() {
      console.log("go");
      sessionStorage.clear();
      localStorage.clear();
      this.loginTrue = true;
      this.$router.push('/login')
      // var item = sessionStorage.getItem("token");

    },

    toggleAll() {
      if (this.allSelected) {
        // 如果全选被勾选，则选中所有权益
        this.selectedRights = this.rights.slice(); // 使用 slice() 来创建数组的一个副本
      } else {
        // 如果全选被取消，则清空已选中的权益
        this.selectedRights = [];
      }
    },
    homeviewSubmit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          if (!this.validateConversionMethod()) {
            return false
          }
          this.syncValuationFields()
          var userId = localStorage.getItem("userId");
          const loginData = {
            depositSubject: this.form.depositSubject,
            author: this.form.author,
            authorIdNumber: this.form.authorIdNumber,
            membersIntroduced: this.form.membersIntroduced,
            memberId: this.form.memberId,
            uploadFiles: this.form.uploadFiles,
            depositName: this.form.depositName,
            depositType: this.form.depositType,
            equityOwnership: this.form.equityOwnership.toString(),
            auditStatus: this.form.auditStatus,
            userId: userId,
            uploadImg: this.form.uploadImg
          };

          this.form.equityOwnership = this.form.equityOwnership.toString()
          this.form.conversionMethod = this.selectedRights.toString()
          Object.assign(loginData, this.form);
          evidence(loginData).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '您的申请已提交，请耐心等待审核',
                type: 'success',
                duration: 3000,
                showClose: true,
                offset: 200
              })
              //清空内容
              this.cleanForm();
              this.showimg = "";
              localStorage.removeItem('formData');
            } else {
              this.$message.error('提交失败')
            }
          }).catch(err => {
            this.$message.error('提交异常')
          })
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      })

    },

    uploadAssessment(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];  // 获取单个文件
        // 生成预览URL
        this.imagePreview = URL.createObjectURL(file);
        this.imagePreview = URL.createObjectURL(file);

        // 调用上传接口
        this.Assessment(file);
      } else {
        this.imagePreview = null;
      }
    },

    async Assessment(file) {
      const response = await uploadImg(file).then(res => {
        if (res.code === 200) {
          this.imgUrl = res.data.newName;
          this.imgShow
          this.form.evaluateSupportingMaterials = this.form.evaluateSupportingMaterials ?
              this.form.evaluateSupportingMaterials + ',' + res.data.newName :
              res.data.newName

          this.form.evaluateSupportingMaterialsName = this.form.evaluateSupportingMaterialsName ?
              this.form.evaluateSupportingMaterialsName + ',' + res.data.originalFilename :
              res.data.originalFilename
        } else {
          console.error('上传失败:', res);
        }
      });
    },
    //上传文件
    handleFileChange(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];  // 获取单个文件
        // 生成预览URL
        this.imagePreview = URL.createObjectURL(file);
        // 调用上传接口
        this.uploadFile(file);
      } else {
        this.imagePreview = null;
      }
    },


    //上传文件的接口
    async uploadFile(file) {
      const response = await uploadImg(file).then(res => {
        if (res.code === 200) {
          console.log('上传成功:', res);
          console.log(res.data.newName);
          this.imgUrl = res.data.newName;
          this.form.uploadFiles = this.form.uploadFiles ?
              this.form.uploadFiles + ',' + res.data.newName :
              res.data.newName
          this.form.originalFilenameUrl = this.form.originalFilenameUrl ?
              this.form.originalFilenameUrl + ',' + res.data.originalFilename :
              res.data.originalFilename
        } else {
          console.error('上传失败:', res);
        }
      });


    },
    queryHashData() {
      const param = {
        certificateNo: this.certificateNo,
        hashValue: this.hashValue,
      }
      certificateQuery(param).then(res => {
        if (res.code === 200) {
          this.queryHash = false;
          this.showPage = false;
          this.formShow = false;
          this.showInfo = false;
          this.imgShow = true;
          this.certificateUrl = res.data.url
          this.showInfoAdmin = false;
        } else {
        }
      })

    },
    queryHashSslect() {
      this.queryHash = true;
      this.showPage = false;
      this.formShow = false;
      this.showInfo = false;
      this.imgShow = false;
      this.showInfoAdmin = false;
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.cities : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
      this.isIndeterminate =
          checkedCount > 0 && checkedCount < this.cities.length;
      this.equityOwnership = checkedCount === this.cities.length;
    },
    showPageHome() {
      this.showPage = true;
      this.formShow = false;
      this.queryHash = false;
      this.showInfo = false;
      this.imgShow = false;
      this.showInfoAdmin = false;
    },
    openGuideVideo() {
      this.guideVideoVisible = true;
      this.$nextTick(() => {
        const player = this.$refs.guideVideoPlayer;
        if (player) {
          player.currentTime = 0;
        }
      });
    },
    handleGuideVideoClose() {
      const player = this.$refs.guideVideoPlayer;
      if (player) {
        player.pause();
      }
    },
    loginUp() {
      this.$router.push("/login");
    },

    isValidUserInfo(body) {
      if (!body) {
        return false
      }
      if (body.code === 200) {
        return true
      }
      if (body.user) {
        return true
      }
      if (body.data && body.data.user) {
        return true
      }
      return false
    },

    extractUserIdFromBody(body) {
      if (!body) {
        return null
      }
      if (body.user && body.user.userId != null) {
        return body.user.userId
      }
      if (body.data && body.data.user && body.data.user.userId != null) {
        return body.data.user.userId
      }
      return null
    },

    /** 校验登录 token 是否有效（含过期检测） */
    async verifyLoginSession() {
      const token = getStoredToken()
      if (!token) {
        this.loginTrue = false
        this.$router.push('/login')
        return false
      }

      try {
        const response = await getInfo(token)
        const body = response && response.data
        if (body && body.code === 401) {
          this.loginTrue = false
          promptReLogin()
          return false
        }
        if (this.isValidUserInfo(body)) {
          const userId = this.extractUserIdFromBody(body)
          if (userId != null) {
            localStorage.setItem('userId', userId)
            sessionStorage.setItem('userId', userId)
          }
          this.loginTrue = true
          return true
        }
        this.loginTrue = false
        promptReLogin()
        return false
      } catch (error) {
        const errBody = error && error.response && error.response.data
        if (errBody && errBody.code === 401) {
          this.loginTrue = false
          promptReLogin()
          return false
        }
        console.error('登录状态校验失败', error)
        this.loginTrue = true
        return true
      }
    },

    openEvidenceForm() {
      this.loginTrue = true
      this.showPage = false
      this.formShow = true
      this.queryHash = false
      this.showInfo = false
      this.imgShow = false
      this.unitAdmin = false
      this.showInfoAdmin = false
    },

    async existingEvidence() {
      if (this.form.achievementName) {
        this.cleanForm();
        this.temporarilyShow = 0
      }

      this.queryLocalStorage()
      const ok = await this.verifyLoginSession()
      if (!ok) return

      this.openEvidenceForm()
    },

    async myInformation() {
      const ok = await this.verifyLoginSession()
      if (!ok) return

      const userId = localStorage.getItem("userId");
      const userInfos = localStorage.getItem("userInfos");
      let management = null
      if (userInfos) {
        try {
          management = JSON.parse(userInfos).management
        } catch (e) {
          console.error('解析用户信息失败', e)
        }
      }
      if (userId === '1') {
        this.showPage = false;
        this.formShow = false;
        this.queryHash = false;
        this.showInfo = false;
        this.imgShow = false;
        this.showInfoAdmin = true;
      } else {
        if (management != null && management === 1) {
          this.unitAdmin = true;
          this.showPage = false;
          this.formShow = false;
          this.queryHash = false;
          this.showInfo = false;
          this.imgShow = false;
          this.showInfoAdmin = false;
        } else {
          this.showPage = false;
          this.formShow = false;
          this.queryHash = false;
          this.showInfo = true;
          this.imgShow = false;
          this.showInfoAdmin = false;
        }
      }
    },

    //清空表单
    cleanForm() {
      this.form = this.cache
      this.selectedRights = [];
      this.allSelected = false;
      this.technicalFieldSelected = '';
      this.technicalFieldOther = '';
      //清空展示照片
      this.handleUploadimgUrl = '';
      this.$refs.uploadRef.clearFiles()
    },

  },
};
</script>

<style scoped lang="scss">


.classLabe2 {
  display: flex;

  .labe2Right {
    margin-left: 40px;
  }
}

.view-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid #8c8c8c;
  background: #333;
  color: #f5f5f5;
  font-size: 14px;
}

.view-icon {
  font-size: 16px;
  margin-right: 6px;
}

.view-text {
  font-size: 14px;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

::v-deep .subClass {
  color: #fff !important;
  background-color: #0077ff !important;
}

.closeClass {
  color: #fff;
  background-color: #ff4d4f;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.clickable {
  color: #0077ff;
  cursor: pointer;
  //text-decoration: underline;
}

.expert-delegate-wrap {
  display: block;
  padding-top: 8px;
}

.expert-delegate-entry {
  cursor: pointer;
  user-select: none;
}

.expert-delegate-gap {
  display: block;
  height: 48px;
  min-height: 48px;
  flex-shrink: 0;
}

.form-label.expert-delegate-link-wrap {
  display: block;
  margin-top: 0 !important;
  margin-bottom: 25px !important;
  cursor: pointer;
}

.expert-delegate-link-wrap .clickable {
  font-size: inherit;
  font-weight: inherit;
}

.bannerBox {
  width: 100%;
}

.layout {
  width: 100%;
}

::v-deep .layout {
  display: flex;
}

.banner_box {
  height: 500px;
}

.banner_box .ban_top .right .no_login {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.banner_box .ban_top .left img {
  width: 176px;
}

.img {
  max-width: 100%;
  border: none;
}

.banner_box .ban_top .left .div2 {
  position: relative;
  margin: 0 40px 0 80px;
  padding: 12px 20px;
  border-radius: 23px;
}

.banner_box {
  background-image: url('~@/assets/img/img1.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 24px 0 190px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-around;

}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.banner_box .ban_text {
  margin: 100px 0 43px;
  font-weight: 600;
  font-size: 54px;
  color: #fff;
  line-height: 71px;
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
  flex: none;
}

.banner_box .btn1,
.banner_box .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.ban_btn {
  margin-top: 410px;
}

.banner_box .ban_btn .btn1 {
  border-radius: 30px;
  border: 2px solid #fff;
  color: #fff;
}

.banner_box .ban_btn .btn2 {
  border-radius: 30px;
  background: #fff;
  color: #333;

}

.banner_box .ban_btn .btn1,
.banner_box .ban_btn .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.banner_box .ban_btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box .step,
.step_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box {
  background: #f7f7f7;
  padding: 90px 0 100px;
}

.step_box .step .step_top {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
}

.step_box .step .step_lab {
  margin-top: 26px;
  font-weight: 400;
  font-size: 20px;
  color: #606266;
  line-height: 27px;
}

.step_box .step .step_itm {
  margin-top: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.step_box .step .step_itms {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.page_width {
  width: 1200px;
  margin-top: 100px;
}

.step_box .step {
  flex-direction: column;
}

.step_box .step .step_itm .itm_box .num {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #2238c2;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 2px solid #2238c2;
}

.step_box .step .step_itms .itm_box .num {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #2238c2;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 2px solid #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 27px;
  width: 15%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itms .line {
  margin-top: 27px;
  width: 15%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 40px;
  width: 10%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itms .line {
  margin-top: 40px;
  width: 10%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.step_box .step .step_itms .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit span {
  color: #2238c2;
}

.reason_box .reason .cont .cont_itm {
  margin-left: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 385px;
  height: 286px;
  padding: 62px 53px 0;
  box-sizing: border-box;
  background: #f5fbfc;
  border-radius: 12px;
  font-size: 16px;
}

.cont_itmDun {

}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exchange_box .exchange .ex_left .tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  margin-bottom: 50px;
}

.exchange_box .exchange .ex_left .tit span {
  color: #2238c2;
}

.exchange_box .exchange .ex_left {
  width: 75%;
}

.exchange_box .exchange .ex_left .itm img {
  width: 24px;
  height: 24px;
  margin-right: 14px;
  font-size: 16px;
}

img {
  max-width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange .ex_left .itm {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  font-size: 16px;
}

.exchange_box {
  padding: 84px 0 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../assets/img/lineImg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

img {
  width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.website {
  padding: 30px 0;
  background: #252525;
  justify-content: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
  color: #a8a8a8;
  background: #252525;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
  line-height: 1.6;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.logo {
  cursor: pointer;
  background-image: url('~@/assets/img/logn.png');
  background-size: 450px 70px;
  width: 450px;
  height: 70px;
  margin-bottom: 25px
}

.problem_box {
  width: 100%;
  background: #fff;
  padding: 90px 0 131px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.problem_box_inline {
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 131px;
}

.problem_box_inline .pro_tit span {
  color: #009eb8;
}

.problem_box_inline .pro_tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
  text-align: center;
  margin-bottom: 80px;
}

.problem_box_inline .pro_lab {
  font-weight: 700;
  margin-bottom: 13px;
  font-size: 20px;
  color: #333;
}

.problem_box_inline .pro_cont {
  font-weight: 400;
  font-size: 16px;
  color: #666;
  line-height: 28px;
}

.mb40 {
  margin-bottom: 40px;
}


.form-container {
  max-width: 1000px;
  margin: 40px auto 90px;
  padding: 36px 44px 32px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(14, 43, 109, 0.10);
}

.steps {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  padding: 0;
  margin-top: 0;
  margin-bottom: 16px;
}

.steps::before {
  display: none;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 1;
  flex: 1;
}

.step-number {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #1890ff, #096dd9);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.35);
}

.step-text {
  font-size: 13px;
  color: #6b7280;
  white-space: nowrap;
}

.step::after {
  display: none;
}

.steps .step:last-child:after {
  display: none;
}

.form-row {
  margin-bottom: 40px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 17px;
  color: #1f2937;
  font-weight: 600;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.form-input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 17px;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
  color: #1f2937;

  &:focus {
    outline: none;
    border-color: #1890ff;
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.12);
  }
}

.radio-group {
  display: flex;
  gap: 20px;
}

.notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-left: 4px solid #faad14;
  padding: 14px 16px;
  border-radius: 6px;
  margin-bottom: 28px;
  font-size: 16px;
  line-height: 1.7;
  color: #595959;
}


.file-upload {
  text-align: center;
  border-radius: 8px;
  transition: border-color 0.2s;
}

.upload-button {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
}

.file-info {
  font-size: 14px;
  color: #666;
  margin-top: 12px;
}

.file-types {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
}

.form-containerquery {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 17px;
  color: #1f2937;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.file-types {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.certificate-type {
  border: 1px solid #e8e8e8;
  padding: 15px;
  margin-bottom: 20px;
}

.certificate-warning {
  color: #ff4d4f;
  font-size: 12px;
  margin-bottom: 10px;
}

.certificate-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.certificate-option {
  border: 1px solid #e8e8e8;
  padding: 15px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}

.certificate-option:hover {
  border-color: #40a9ff;
}

.certificate-option.selected {
  border-color: #1890ff;
  background-color: #e6f7ff;
}

.certificate-option img {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.rights-section {
  margin-bottom: 22px;
}

.rights-grid {
  width: 100%;
  margin: 10px 0 0;
  display: flex;
  flex-wrap: wrap;
}

.right-option {
  width: 25%;
  display: flex;
  align-items: center;
  font-size: 17px;
  margin-bottom: 12px;

  input {
    width: 17px;
    height: 17px;
    margin-right: 8px;
    cursor: pointer;
  }

  label {
    color: #374151;
    cursor: pointer;
  }
}

.agreement {
  display: flex;
  align-items: center;

  margin-bottom: 20px;
  justify-content: center;

  input {
    width: 16px;
    height: 16px;
  }
}


.agreement a {
  color: #1890ff;
  text-decoration: none;
}

.submit-buttonLeft {
  background: #fff;
  color: #1890ff;
  border: 2px solid #1890ff;
  padding: 11px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 17px;
  font-weight: 600;
  text-align: center;
  transition: background 0.2s;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  line-height: 1.2;
  white-space: nowrap;

  &:hover {
    background: #e6f4ff;
  }
}

.temp-store-main {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.submit-buttonRight {
  background: linear-gradient(135deg, #1890ff, #096dd9);
  color: white;
  border: none;
  padding: 11px 36px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 17px;
  font-weight: 600;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  transition: all 0.2s;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
  }
}

.changeEvidence {
  background: linear-gradient(135deg, #1890ff, #096dd9);
  color: white;
  border: none;
  padding: 11px 36px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 17px;
  font-weight: 600;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.changeEvidence:hover {
  background: linear-gradient(135deg, #40a9ff, #1890ff) !important;
  color: white;
}

.submit-button:hover {
  background: #40a9ff;
}

.notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-left: 4px solid #faad14;
  padding: 14px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.7;
  color: #595959;
}

.submitClass {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 24px 0 8px;
  margin-top: 16px;
  border-top: 1px solid #f0f4f8;
}

.temp-store-tip {
  font-size: 13px;
  font-weight: 400;
  color: #8c8c8c;
}

.valuation-type-section {
  background: #f8faff;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  padding: 18px 20px 12px;
  margin-bottom: 20px;
}

.valuation-tip-text {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #9ca3af;
}

.valuation-type-title {
  font-size: 17px;
  font-weight: 600;
  color: #1e3a5f;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0edff;
  display: flex;
  align-items: center;
  gap: 6px;
}

.comprehensive-section {
  padding-top: 4px;
}

.delegate-btn {
  border-radius: 6px;
}

.optional-tag {
  font-size: 14px;
  font-weight: 400;
  color: #9ca3af;
  margin-left: 4px;
}

.required-tag {
  font-size: 14px;
  font-weight: 400;
  color: #e6a23c;
  margin-left: 4px;
}

.cha_xun {
  padding: 3.5rem 18.33rem 10.42rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .tips {
    font-size: 1.33rem;
    font-family: Microsoft YaHei, serif;
    font-weight: 400;
    color: #232323;
    line-height: 2.25rem;
  }
}


.cha_xun .tips {
  margin-top: 2.08rem;
  padding: 0.92rem 1.92rem 3.25rem;
  background: rgba(39, 130, 255, 0.1);
  border: 1px solid #2782ff;
  border-radius: 0.25rem;
  display: flex;
  align-items: baseline;
}


.cha_xun .tips div[data-v-71571416] {
  font-size: 1.33rem;
  font-weight: 400;
  color: #232323;
  line-height: 2.25rem;
  font-size: 20px;
}

.cha_xun .input_box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cha_xun .file_hash[data-v-71571416],
.cha_xun .unified_numbering[data-v-71571416] {
  display: flex;
  align-items: center;
  margin-top: 4.25rem;
}

.cha_xun .file_hash .el-input[data-v-71571416] .el-input__inner,
.cha_xun .unified_numbering .el-input[data-v-71571416] .el-input__inner {
  border-radius: 0.25rem;
  font-size: 1.4rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.cha_xun .query[data-v-71571416] {
  cursor: pointer;
  margin-top: 5.67rem;
  padding: 1.17rem 10rem;
  display: inline-block;
  background: #2782ff;
  box-shadow: 0 0.3rem 3rem 0 rgba(29, 62, 187, 0.2);
  border-radius: 0.25rem;
  font-size: 1.67rem;
  font-weight: 700;
  color: #fff;
  line-height: 2rem;
}

.cha_xun .file_hash .filed[data-v-71571416],
.cha_xun .unified_numbering .filed[data-v-71571416] {
  display: flex;
  align-items: center;
}

.querytext {
  display: flex;
  width: 100px;
  font-size: 20px;
}

/* 相对页面内容区左右各约 24px 留白；最大宽度 1600px（避免用 100vw 含滚动条导致右侧被裁切） */
.me {
  width: calc(100% - 48px);
  max-width: 1600px;
  margin: 90px auto 90px;
  padding: 20px 0;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  //box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.imgSh {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10%;
  margin-top: 50px;
  margin-bottom: 50px;
}

.tipMessage {
  font-size: 17px;
}

.no_login {

}

.label {
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}


::v-deep .labe2 {
  font-size: 16px;
}

.no_loginLeft {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.no_loginRight {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
  margin-left: 10px;
}

.el-dropdownClass {
  width: 50%;
}


.dataclass {
  font-size: 15px;
}

.el-textarea .el-input__count {
  margin-bottom: 10px !important;
}

.technical-field-other {
  margin-top: 8px;
  max-width: 480px;
}

.right-optionValue {
  width: 25%;
  display: flex;
  align-items: center;
  font-size: 17px;
  margin-bottom: 12px;

  input {
    width: 17px;
    height: 17px;
    margin-right: 8px;
    cursor: pointer;
  }

  label {
    color: #374151;
    cursor: pointer;
  }
}

::v-deep .el-icon-close {
  font-size: 20px !important;
}

::v-deep .el-upload-list__item-name {
  font-size: 20px !important;
  color: #f56c6c !important;
}

::v-deep .el-upload-list__item .el-icon-upload-success {
  font-size: 20px !important;
}

.el-upload__tip {
  font-size: 20px;
}

::v-deep .el-upload {
  width: 100%;
}

::v-deep .el-upload-dragger {
  width: 100%;
  height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8faff;
  border-color: #c8d6e8;
}

::v-deep .el-upload-dragger:hover {
  border-color: #1890ff;
}

::v-deep .el-upload-dragger .el-icon-upload {
  font-size: 52px;
  margin-bottom: 8px;
  margin-top: 0;
  line-height: 1;
}

::v-deep .el-upload-dragger .el-upload__text {
  font-size: 16px;
}

::v-deep .el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  justify-content: center !important;
  display: flex !important;
}

.guide-video-fab {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 10px;
  background: linear-gradient(180deg, #1890ff, #096dd9);
  color: #fff;
  border-radius: 0 12px 12px 0;
  box-shadow: 2px 0 16px rgba(24, 144, 255, 0.35);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  user-select: none;

  &:hover {
    transform: translateY(-50%) translateX(3px);
    box-shadow: 4px 0 20px rgba(24, 144, 255, 0.45);
  }

  i {
    font-size: 22px;
  }

  &__text {
    font-size: 13px;
    font-weight: 500;
    writing-mode: vertical-rl;
    letter-spacing: 2px;
  }
}

.guide-video-wrap {
  width: 100%;
}

.guide-video-player {
  display: block;
  width: 100%;
  max-height: 70vh;
  border-radius: 6px;
  background: #000;
}

.guide-video-empty {
  padding: 40px 20px;
  text-align: center;
  color: #909399;
  font-size: 15px;
  line-height: 1.6;
}

::v-deep .guide-video-dialog {
  .el-dialog__body {
    display: block !important;
    padding: 16px 20px 24px;
  }
}

</style>
